import { logger as nxLogger } from 'nx/src/utils/logger'

const isLoggerEnabled = (): boolean => {
    if (typeof window === 'undefined') {
        return false
    }

    const urlParams = new URLSearchParams(window.location.search)
    const urlLoggerParam = urlParams.get('dccLoggerEnabled')

    // If explicitly disabled via URL, clear persisted state and return false
    if (urlLoggerParam === '0') {
        sessionStorage.removeItem('dccLoggerEnabled')
        return false
    }

    // If enabled via URL, persist it
    if (urlLoggerParam === '1') {
        sessionStorage.setItem('dccLoggerEnabled', '1')
        return true
    }

    // Check persisted state only if no URL parameter is present
    const persistedLoggerEnabled = sessionStorage.getItem('dccLoggerEnabled') === '1'

    return persistedLoggerEnabled
}

export const logger = {
    info: (message: string, ...args: any[]) => {
        if (isLoggerEnabled()) {
            (nxLogger.info as any)(message, ...args)
        }
    },
    warn: (message: string, ...args: any[]) => {
        if (isLoggerEnabled()) {
            (nxLogger.warn as any)(message, ...args)
        }
    },
    error: (message: string, ...args: any[]) => {
        if (isLoggerEnabled()) {
            (nxLogger.error as any)(message, ...args)
        }
    },
    debug: (message: string, ...args: any[]) => {
        if (isLoggerEnabled()) {
            nxLogger.debug?.(message, ...args)
        }
    },
    log: (message: string, ...args: any[]) => {
        if (isLoggerEnabled()) {
            nxLogger.log?.(message, ...args)
        }
    },
}

export const traceLogger = {
    info: (message: string) => {
        (nxLogger.info as any)(message)
    },
    warn: (message: string) => {
        (nxLogger.warn as any)(message)
    },
}

export const enableLogger = () => {
    sessionStorage.setItem('dccLoggerEnabled', '1')
}

export const disableLogger = () => {
    sessionStorage.removeItem('dccLoggerEnabled')
}

export const isLoggerCurrentlyEnabled = () => isLoggerEnabled()

export default logger
